// v1.0.0 - 2026-01-28 - Login page

import { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/lib/stores/authStore'
import { LoginForm } from '@/components/auth/LoginForm'
import { MagicLinkForm } from '@/components/auth/MagicLinkForm'

export default function LoginPage() {
  const { isAuthenticated, user } = useAuthStore()
  const [mode, setMode] = useState<'password' | 'magic'>('password')

  // Redirect if already authenticated
  if (isAuthenticated && user) {
    return <Navigate to={user.role === 'admin' ? '/admin' : '/member'} replace />
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--color-bg-secondary)]">
      <div className="w-full max-w-md space-y-6 px-4">
        {/* Logo / Brand */}
        <div className="text-center">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-[var(--color-primary)] text-white text-2xl font-bold">
            C
          </div>
          <h1 className="mt-4 text-2xl font-bold text-[var(--color-text-primary)]">
            CER Webapp
          </h1>
          <p className="mt-1 text-sm text-[var(--color-text-secondary)]">
            Gestione Comunita Energetiche Rinnovabili
          </p>
        </div>

        {/* Login Form */}
        {mode === 'password' ? <LoginForm /> : <MagicLinkForm />}

        {/* Toggle Mode */}
        <div className="text-center">
          <button
            onClick={() => setMode(mode === 'password' ? 'magic' : 'password')}
            className="text-sm text-[var(--color-accent)] hover:underline"
          >
            {mode === 'password'
              ? 'Accedi con magic link'
              : 'Accedi con password'}
          </button>
        </div>
      </div>
    </div>
  )
}
